import { StyledToolbarButton, StyledTooltip } from '../../../../shared/styles/components/integrations.styles';

import React from 'react';
import arrowsInwardIcon from '@ingka/ssr-icon/paths/arrows-inward';
import { theme } from '../../../../shared/styles/core/theme';
import { useCompactMode } from '../../../../shared/state/compact-mode.state';
import styled from '../../../../shared/types/transient-styled.types';

const ActiveToolbarButton = styled(StyledToolbarButton)`
   background-color: ${theme.colors.border.focus};
   color: ${theme.colors.text.inverse};
`;

export const CompactToggle: React.FC = () => {
    const { isCompact, toggleCompact } = useCompactMode();
    const Btn = isCompact ? ActiveToolbarButton : StyledToolbarButton;
    return (
        <StyledTooltip title={isCompact ? 'Switch to comfortable spacing' : 'Switch to compact spacing'}>
            <Btn ssrIcon={arrowsInwardIcon} text="Toggle compact mode" iconOnly small onClick={toggleCompact} />
        </StyledTooltip>
    );
};
